import { useState } from 'react';
import { Flex, IconButton } from '@elementary/common-ui/components';
import { Tooltip } from '@mui/material';
import { ReactComponent as VisibilityIcon } from '@elementary/common-ui/assets/inspect.svg';
import { ReactComponent as TrashIcon } from '@elementary/common-ui/assets/trash.svg';
import styled from 'styled-components';
import { GPGKey } from '../types';
import ShowPublicKeyDialog from './ShowPublicKeyDialog';
import RevokeKeyDialog from './RevokeKeyDialog';

const StyledVisibilityIcon = styled(VisibilityIcon)`
  path {
    fill: ${({ theme }) => theme.palette.common.gray2};
  }
`;

const StyledTrashIcon = styled(TrashIcon)`
  path {
    fill: ${({ theme }) => theme.palette.error.main};
  }
`;

interface Props {
  gpgKey: GPGKey;
}

const GPGKeyActions = ({ gpgKey }: Props) => {
  const [showPublicKeyDialog, setShowPublicKeyDialog] = useState(false);
  const [showRevokeDialog, setShowRevokeDialog] = useState(false);

  return (
    <>
      <Flex
        sx={{ justifyContent: 'flex-start', gap: 0.5, alignItems: 'center' }}
      >
        <Tooltip title="Show Public Key" placement="left">
          <IconButton size="small" onClick={() => setShowPublicKeyDialog(true)}>
            <StyledVisibilityIcon />
          </IconButton>
        </Tooltip>

        {gpgKey.isActive && (
          <Tooltip title="Revoke Key" placement="left">
            <IconButton size="small" onClick={() => setShowRevokeDialog(true)}>
              <StyledTrashIcon width={16} height={16} />
            </IconButton>
          </Tooltip>
        )}
      </Flex>

      <ShowPublicKeyDialog
        isOpen={showPublicKeyDialog}
        onClose={() => setShowPublicKeyDialog(false)}
        gpgKey={gpgKey}
      />

      <RevokeKeyDialog
        isOpen={showRevokeDialog}
        onClose={() => setShowRevokeDialog(false)}
        gpgKey={gpgKey}
      />
    </>
  );
};

export default GPGKeyActions;
